import React, { useEffect, useState } from "react";
import store from "@/redux/store";
import BaseDialog from "@/components/dialog/BaseDialog";
import { TablePagination } from "@/components/holders/TablePagination";
import { Link, useNavigate, useLocation } from "react-router-dom";


import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import DB from "@/models/DB";


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Search(props) {
    const [tableItems, setTableItems] = useState(((props?.items) ? props?.items : []));
const createDossierEventHandler=((event, item) => {
   if(props?.modalOptions?.createNewDossierHandler) {
       props?.modalOptions?.createNewDossierHandler(event, item);
   }
 });

useEffect(() => {
   let mounted = true;
   setTableItems(props.items);
   return () => mounted = false;
 }, [props?.items])    

const onSearch= (e) => {
    let filterItems =  props.items.items.filter((item) =>  {
        if(item.name.includes( e.target.value)) {
            return item;
            
        }
        return false;
        
    });
    
    setTableItems( DB.newCollection(filterItems) );
}   

const searchSector = (sectorId) =>  {
    let retVal = "";
    if(sectorId && props?.wp_sectors) {
        let sector = props?.wp_sectors.where('id', sectorId).get(true);
        retVal = sector.first().name;
    }
    
    return retVal;
}

const searchDepartment = (sectorId) =>  {
    let retVal = "";
    if(sectorId && props?.wp_sectors) {
        let sector = props?.wp_departments.where('id', sectorId).get(true);
        retVal = sector.first().name;
    }
    
    return retVal;
}


    return (
        <BaseDialog {...props} nofooter>
            <div className="flex flex-col h-[90vh]">
            <div className="h-10">
            <h1>Werkprocessen</h1>
            </div>
            
                          <thead className=" ">
                <tr className="flex flex-row">
                  <th scope="col" className="px-0 py-3.5 text-left text-sm font-semibold text-gray-900 w-48 flex-initial">
                    Sector
                  </th>
                  <th scope="col" className="px-0 py-3.5 text-left text-sm font-semibold text-gray-900 w-48 flex-initial">
                    Afdeling
                  </th>
                  <th scope="col" className="px-0 py-3.5 text-left text-sm font-semibold text-gray-900 flex-1">
                    Naam
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>

                          <thead>
                <tr className="flex flex-row">
                  <th scope="col" className="px-0 py-0 text-left text-sm font-semibold text-gray-900 w-48 flex-initial"></th>
                  <th scope="col" className="px-0 py-0 text-left text-sm font-semibold text-gray-900 w-48 flex-initial"></th>
                  <th scope="col" className="px-0 py-0 text-left text-sm font-semibold text-gray-900 flex-1">

        <input
          id="filter_name"
          name="filter_name"
          type="text"
          onChange={(e) => onSearch(e)}
          placeholder="Zoek op naam"
          className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
        />

                </th>
                          <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0 w-32 flex-initial">
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>

            
            <div className="overflow-x-hidden  grow h-[90vh]">
            
            <table className="min-w-full divide-y divide-gray-300">
              <tbody className="divide-y divide-gray-200 overflow-y-show">
                {tableItems && tableItems.items && tableItems.items.map((item) => (
                  <tr key={item.id} className="flex flex-row">
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0  w-48 flex-initial">
                            { searchSector(item.organization_sector_id)}
                    </td>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0  w-48 flex-initial">
                            { searchDepartment(item.work_sector_id)}
                    </td>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 flex-1">
                            {item.name}
                    </td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 mr-5">
                        <button onClick={(event) => createDossierEventHandler(event, item)} className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 mr-2">
                            Dossier aanmaken<span className="sr-only">, {item.name}</span>
                        </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            <TablePagination className="mt-2 h-10" data={props?.data}/>
            </div>
        
        </BaseDialog>
    )
}